import { ApiResponse, AxiosErrorCustom, axiosInstance } from '@/lib/axios';
import { z } from 'zod';
import { TypedMutationConfig } from '@/lib/react-query';
import { useMutation } from '@tanstack/react-query';

export const CreateTicketValidationSchema = z.object({
  spaceId: z.string({ required_error: 'Space ID is required' }),
  title: z.string({ required_error: 'Title is required' }).min(1, 'Title Ticket is required!'),
  spaceColumnId: z.string({ required_error: 'Space column ID is required' }),
  position: z.string().optional(),

  startDate: z.string().optional(),
  endDate: z.string().optional(),
  content: z.string().max(30000, 'Content must be at most 30000 characters').optional(),
  labelTicketIds: z.array(z.string()).optional(),
  userIds: z.array(z.string()).optional(),
  caseIds: z.array(z.string()).optional(),
  attachments: z
    .array(
      z.object({
        fileName: z.string(),
        size: z.number(),
        uri: z.string(),
        contentType: z.string(),
      })
    )
    .optional(),
  note: z.string().optional(),
});
export type TCreateTicketValidation = z.infer<typeof CreateTicketValidationSchema>;
export type TCreateTicketPayload = TCreateTicketValidation;
export type TCreateTicketResponse = ApiResponse<{
  message: string;
}>;

export const createTicket = async (payload: TCreateTicketPayload): Promise<TCreateTicketResponse> => {
  const url = `/ticket`;

  return axiosInstance.post(url, payload);
};

/**
 * Use Create Ticketing Ticket React-Query Hook
 */
type UseCreateTicketMutationOptions = {
  mutationConfig?: TypedMutationConfig<typeof createTicket, AxiosErrorCustom>;
};

/**
 * Use Create Ticketing Ticket React-Query Hook
 */
export const useCreateTicketMutation = ({ mutationConfig }: UseCreateTicketMutationOptions) => {
  const { ...restConfig } = mutationConfig ?? {};

  return useMutation({
    mutationFn: createTicket,
    ...restConfig,
  });
};
